import { render } from "./PartialCheckbox.vue?vue&type=template&id=533f2336&scoped=true&ts=true"
import script from "./PartialCheckbox.vue?vue&type=script&lang=ts"
export * from "./PartialCheckbox.vue?vue&type=script&lang=ts"

import "./PartialCheckbox.vue?vue&type=style&index=0&id=533f2336&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533f2336"]])

export default __exports__